<template>
    <dx-grid
        name="tip-grid"
        :url="url"
        :beforeSetupGrid="beforeSetupGrid"
        :columns="tipTransactionColumns"
        :title="title"
        ref="grid"
        :actions="actions"
        :expandedOptions="{
            enabled: true,
            allowExpandingAll: true,
            template: 'tip-transaction-details',
        }"
        :summaryOptions="{
            enabled: true,
            columns: ['amount'],
        }"
    ></dx-grid>
</template>

<script>
import moment from "moment";
import { formatCurrency, toISOLocal } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Tip Payments",
        url: "",
        fromDate: "",
        actions: [],

        tipTransactionColumns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                icon: (value, row) => {
                    if (!value) return "";

                    switch (value) {
                        case "PROCESSED":
                            return "mdi-check-circle";
                        case "SCHEDULED":
                            return "mdi-clock";
                        case "VOIDED":
                        case "CANCELED":
                            return "mdi-cancel";
                        case "ERROR":
                            return "mdi-alert-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    if (!value) return "";

                    switch (value) {
                        case "PROCESSED":
                            return "success";
                        case "SCHEDULED":
                            return "#fdb400";
                        case "VOIDED":
                        case "CANCELED":
                            return "#aeb8bf";
                        case "ERROR":
                            return "#f35123";
                        default:
                            return "";
                    }
                },
            },
            {
                label: "Teacher Code",
                field: "teacherCode",
                visible: true,
                link: "TeacherView",
                template: "link-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Hebrew",
                field: "teacherH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Amount",
                field: "amount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered On",
                field: "enteredOn",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date Printed",
                field: "datePrinted",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date Voided",
                field: "dateVoided",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Type",
                field: "teacherType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Check Number",
                field: "checkNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Mailing Address",
                field: "mailingAddress",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    methods: {
        beforeSetupGrid() {
            this.fromDate = toISOLocal(
                new Date(moment().subtract(1, "weeks")),
            ).substr(0, 10);

            this.actions.push({
                text: "From Date",
                type: "datepicker",
                value: this.fromDate,
                onChanged: this.onDateChanged,
                action: this.onDateChanged,
                align: "left",
            });

            this.url = "tipPayments?fromDate=" + this.fromDate + "&employeeID=";
        },
        onDateChanged(value) {
            this.fromDate = value;
            this.url = "tipPayments?fromDate=" + this.fromDate + "&employeeID=";

            this.$refs.grid.reloadDataSource(this.url);
        },
    },
};
</script>
<style></style>
